const API_URLS = {
  getOffersVday: 'https://api-mobile-ci-vfal.vodafone.com/public/paymentVoucherAPI-sparkling/v2/paymentVoucher/search',
}

const COMMON_HEADERS = {
  'Content-Type': 'application/json',
}

export { API_URLS, COMMON_HEADERS }
